export default class TripContent {
  constructor({title, quantity}) {
    this.title = title;
    this.quantity = quantity;
  }
}
